import {BBModel} from "../bb_model";

const eventSequence = {
    query(company, params) {
        return new Promise((resolve, reject) => {
            if (!company.$has('event_sequences')) {
                reject('company does not have event_sequences');
            } else {
                company.$get('event_sequences', params).then((resource) => {
                        return resource.$get('event_sequences', params).then((event_sequences) => {
                                event_sequences = Array.from(event_sequences).map(event_sequence =>
                                    new BBModel.EventSequence(event_sequence));
                                return resolve(event_sequences);
                            }
                        );
                    }
                    , (err) => {
                        return reject(err);
                    }
                );
            }
        });
    }
};

export {
    eventSequence
}

